import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ReportsService } from '../../../Services/reports.service';
import { MasterInformationService } from '../../../Services/master-information.service';
import { DashboardService } from '../../../Services/dashboard.service';
import { apiEndPoints } from '../../../api/apiEndPoint';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-requestor-summary-report',
  standalone: true,
  providers: [DatePipe],
  imports: [
    CommonModule,
    FormsModule,
    NgbPaginationModule,
    ReactiveFormsModule,
  ],
  templateUrl: './requestor-summary-report.component.html',
  styleUrls: ['./requestor-summary-report.component.css'],
})
export class RequestorSummaryReportComponent implements OnInit {
  // Dropdown options
  userTypes = [
    'All',
    'Individual Requestor',
    'Corporate Requestor',
    'Dumpster',
    'Dump Yard',
  ];
  cities = ['Abqaiq', 'Riyadh', 'Jeddah', 'Dammam', 'Al Khobar'];
  zones = ['AlFardous', 'Zone 1', 'Zone 2', 'Zone 3'];

  // Selected filters
  selectedUserType: any;
  selectedCity: string = '';
  selectedZone: string = '';
  searchText: string = '';
  cityList: any;
  selectedCityId: any;
  zoneList: any;
  selectedZoneId: any;
  userTypeList: any;
  allUserList: any;
  userById: any;
  userId: any;
  userType: any;
  userName: any;

  // ---------------------- Pagination ---------------------- //
  page = 1;
  pageSize = 12;
  companyName: any;
  fromDate: any;
  isToDateShow: boolean = false;
  toDate: any;
  selectedUserForDate: any;
  userIdForDate: any;
  ngFromDate: any;
  ngToDate: any;
  filteredUserList: any;

  constructor(
    private reportService: ReportsService,
    private masterService: MasterInformationService,
    private toastr: ToastrService,
    private dashService: DashboardService,
    private datePipe: DatePipe
  ) {}

  // -------------------------------------- OnInit -------------------------------------- //

  ngOnInit() {
    this.filteredUsers = this.allUserList;
    this.getCity();
    this.getUserType();
    this.allUsers();
  }

  //  ----------------------------------- Get UserType List ----------------------------------- //

  getUserType() {
    this.reportService.getUserTypeList(apiEndPoints.userType).subscribe({
      next: (response: any) => {
        let userType = [1, 2, 3, 4];
        this.userTypeList = response.body.details.filter((user: any) =>
          userType.includes(user.id)
        );
      },
      error: (error) => {
        this.toastr.error(
          'An unexpected error occurred. Please try again later.',
          'Error',
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          }
        );
      },
    });
  }

  //  ----------------------------------- On UserType Change ----------------------------------- //

  onUserTypeChange(event: any) {
    const selectedUserType = (event.target as HTMLSelectElement).value;
    this.selectedUserType = selectedUserType;
    this.userById = undefined;
    this.allUsers();
  }

  // ----------------------------------- Get All City List API ----------------------------------- //

  getCity() {
    this.masterService.getCityList(apiEndPoints.cityList).subscribe({
      next: (response: any) => {
        this.cityList = response.body?.details;
      },
      error: (error) => {
        this.toastr.error(
          'An unexpected error occurred. Please try again later.',
          'Error',
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          }
        );
      },
    });
  }

  // ----------------------------------- City Change Dropdown ----------------------------------- //

  onCityChange(event: Event) {
    const selectedCity = (event.target as HTMLSelectElement).value;
    this.selectedCityId = selectedCity;
    this.userById = undefined;
    this.getZone();
    this.allUsers();
    // this.calculateThreeMonthsBefore()
  }

  // ----------------------------------- Get All Zone List API ----------------------------------- //

  getZone() {
    this.dashService
      .getZoneList(apiEndPoints.zoneList, this.selectedCityId)
      .subscribe({
        next: (response: any) => {
          this.zoneList = response.body.details;
        },
        error: (error) => {
          this.toastr.error(
            'An unexpected error occurred. Please try again later.',
            'Error',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
        },
      });
  }

  // ----------------------------------- Zone Change Dropdown ----------------------------------- //

  onZoneChange(event: Event) {
    const selectedZoneId = (event.target as HTMLSelectElement).value;
    this.selectedZoneId = selectedZoneId;
    this.allUsers();
  }

  // ----------------------------------- Get All Users ----------------------------------- //

  allUsers() {
    this.reportService
      .getAllUserSummary(
        apiEndPoints.summaryUserList,
        this.selectedUserType,
        this.selectedCityId,
        this.selectedZoneId
      )
      .subscribe({
        next: (response: any) => {
          let allowedTypes = ['1', '2', '3', '4'];
          this.allUserList = response.body?.details.filter((data: any) =>
            allowedTypes.includes(data.userType)
          );
          this.filteredUserList = [...this.allUserList];
        },
        error: (error) => {
          this.toastr.error(
            'An unexpected error occurred. Please try again later.',
            'Error',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
        },
      });
  }

  getType(type: any): string {
    switch (type) {
      case '1':
      case 1:
        return 'Individual Requester';
      case '2':
      case 2:
        return 'Corporate Requester';
      case '3':
      case 3:
        return 'Dumpster';
      case '4':
      case 4:
        return 'Dumpyard';
      default:
        return 'Unknown'; // Handle cases where the status is unexpected
    }
  }

  // ----------------------------------- Get Users List By Id ----------------------------------- //

  getUsersById(user: any) {
    if (!user || !user.userId) {
      console.error('Invalid user object:', user);
      return;
    }

    this.selectedUserForDate = user;
    this.userId = user.userId;
    this.userName = user.userName;
    this.companyName = user.companyName;
    this.userType = user.userType;

    console.log('User for date filtering:', this.selectedUserForDate);

    this.reportService
      .getUserSummaryById(
        apiEndPoints.userSummary,
        this.userId,
        this.fromDate,
        this.toDate
      )
      .subscribe({
        next: (response: any) => {
          this.userById = response.body.details;
          console.log(this.userById);
        },
        error: (error) => {
          this.toastr.error(
            'An unexpected error occurred. Please try again later.',
            'Error',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
        },
      });
  }

  // ----------------------------- Pagination ----------------------------- //
  get pagedData() {
    const start = (this.page - 1) * this.pageSize;
    const end = this.page * this.pageSize;
    return this.userById?.slice(start, end);
  }

  onPageChange(page: number): void {
    this.page = page;
  }

  // ----------------------------------- Date Filter ----------------------------------- //

  onFromDateChange(event: any) {
    this.fromDate = event.target.value;
    this.ngFromDate = this.fromDate;
    this.ngToDate = '';
    this.toDate = '';
    this.isToDateShow = true;
  }

  // ---------------- To Date Change ---------------- //
  onToDateChange(event: any) {
    this.toDate = event.target.value;

    if (new Date(this.toDate) < new Date(this.fromDate)) {
      this.toastr.info('To Date cannot be before From Date!', 'Info', {
        timeOut: 3000,
        positionClass: 'toast-top-right',
        progressBar: true,
      });
      this.ngToDate = '';
      this.toDate = '';
      return;
    }

    this.ngToDate = this.toDate;

    if (!this.selectedUserForDate) {
      console.error('No user selected before filtering by date!');
      return;
    }

    this.getUsersById(this.selectedUserForDate);
  }

  // Filtered user list
  filteredUsers: any[] = [];
  currentPage: number = 1; // Pagination: current page
  itemsPerPage: number = 5; // Items per page

  // Selected user
  selectedUser: any = null;

  filterUsers() {
    const search = this.searchText.toLowerCase();
    this.filteredUserList = this.allUserList.filter((user: any) => {
      return (
        user.userName?.toLowerCase().includes(search) ||
        user.companyName?.toLowerCase().includes(search) ||
        user.phoneNo?.toLowerCase().includes(search)
      );
    });
  }

  // Calculate column totals for the selected user's records
  getColumnTotal(column: string): number {
    if (!this.selectedUser) return 0;
    return this.selectedUser.records.reduce(
      (sum: number, record: any) => sum + (record[column] || 0),
      0
    );
  }

  // ------------------------------- Export to Excel ------------------------------- //
  exportToExcel(): void {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.filteredUsers);
    const wb: XLSX.WorkBook = { Sheets: { data: ws }, SheetNames: ['data'] };
    XLSX.writeFile(wb, 'On&OffBuisnessList.xlsx');
  }

  exportToPDF() {
    const doc = new jsPDF('landscape');
    const pageWidth = doc.internal.pageSize.width;
    const pdfFileName = 'User-Summary-Report.pdf';

    const logo = new Image();
    logo.src = 'assets/Images/CDM-01.png';
    logo.onload = () => {
      const logoWidth = 28;
      const logoHeight = 20;
      const logoX = (pageWidth - logoWidth) / 2;
      const logoY = 10;
      doc.addImage(logo, 'PNG', logoX, logoY, logoWidth, logoHeight);

      const arabicAddressImg = new Image();
      arabicAddressImg.src = 'assets/Images/arabic address.jpeg';
      arabicAddressImg.onload = () => {
        const arabicImgWidth = 70;
        const arabicImgHeight = 20;
        const arabicImgX = pageWidth - arabicImgWidth - 10;
        const arabicImgY = 10;
        doc.addImage(
          arabicAddressImg,
          'JPEG',
          arabicImgX,
          arabicImgY,
          arabicImgWidth,
          arabicImgHeight
        );

        // Add website below Arabic address image
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 255);
        doc.text(
          'www.smart­sort.net',
          arabicImgX + arabicImgWidth / 2,
          arabicImgY + arabicImgHeight + 5,
          { align: 'left' }
        );

        const englishAddressImg = new Image();
        englishAddressImg.src = 'assets/Images/english address.jpeg';
        englishAddressImg.onload = () => {
          const englishImgWidth = 70;
          const englishImgHeight = 20;
          const englishImgX = 10;
          const englishImgY = 10;
          doc.addImage(
            englishAddressImg,
            'JPEG',
            englishImgX,
            englishImgY,
            englishImgWidth,
            englishImgHeight
          );

          // Add website below English address image
          doc.setFontSize(10);
          doc.setTextColor(0, 0, 255);
          doc.text(
            'www.smart­sort.net',
            englishImgX + englishImgWidth / 11,
            englishImgY + englishImgHeight + 5,
            { align: 'left' }
          );

          // Reset text color to black (optional, in case you add more text later)
          doc.setTextColor(0, 0, 0);

          doc.setFont('helvetica', 'bold');
          doc.setFontSize(14);
          const title = 'User Summary Report';
          const titleY = logoY + logoHeight + 10;
          doc.text(title, pageWidth / 2, titleY, { align: 'center' });

          // Table headers
          const headers = [
            [
              { content: 'Year' },
              { content: 'Month' },
              { content: 'Total Orders' },
              { content: 'No Of Containers Booked (NOS)' },
              { content: 'No Of Trips Achieved' },
              { content: 'Total Quantity Disposed (TONS)' },
              ...(this.userType === '1' || this.userType === '2'
                ? [
                    { content: 'SAR Received From Requestor' },
                    { content: 'SAR Refunded to Requestor' },
                  ]
                : []),
              ...(this.userType === '3'
                ? [{ content: 'SAR Allocated Dumpster' }]
                : []),
              ...(this.userType === '4'
                ? [{ content: 'SAR Allocated Dump Yard' }]
                : []),
            ],
          ];

          let tableBody: any[] = [];

          // Populate table body dynamically based on headers
          this.pagedData.forEach((record: any) => {
            const row = [
              record.year,
              record.month,
              record.totalorders,
              record.noOfContainerBooked,
              record.noOfTripAchieved,
              record.totalTonDisposed,
            ];

            headers[0].forEach((header: any) => {
              switch (header.content) {
                case 'SAR Received From Requestor':
                  row.push(record.sarReceivedFromRequestor || 0);
                  break;
                case 'SAR Refunded to Requestor':
                  row.push(record.sarReFundedToRequestor || 0);
                  break;
                case 'SAR Allocated Dumpster':
                  row.push(record.sarAllocatedDumpster || 0);
                  break;
                case 'SAR Allocated Dump Yard':
                  row.push(record.sarAllocatedDumpyard || 0);
                  break;
              }
            });

            tableBody.push(row);
          });

          // Add table footer for totals
          const footer = [
            {
              content: 'Total:',
              colSpan: 2,
              styles: { halign: 'center', fontStyle: 'bold' },
            },
            this.getColumnTotal('totalOrders'),
            this.getColumnTotal('noOfContainerBooked'),
            this.getColumnTotal('noOfTripAchieved'),
            this.getColumnTotal('totalTonDisposed'),
          ];

          if (this.userType === '1' || this.userType === '2') {
            footer.push(
              this.getColumnTotal('sarReceivedFromRequestor'),
              this.getColumnTotal('sarReFundedToRequestor')
            );
          }

          if (this.userType === '3') {
            footer.push(this.getColumnTotal('sarAllocatedDumpster'));
          }

          if (this.userType === '4') {
            footer.push(this.getColumnTotal('sarAllocatedDumpyard'));
          }

          tableBody.push(footer);

          // Generate table
          autoTable(doc, {
            startY: titleY + 10,
            head: headers,
            body: tableBody,
            styles: {
              fontSize: 8,
              cellPadding: 2,
              lineWidth: 0.3,
              lineColor: [50, 50, 50],
              halign: 'center',
            },
            theme: 'grid',
            headStyles: {
              fillColor: [176, 220, 101],
              textColor: [0, 0, 0],
              fontStyle: 'bold',
              lineColor: [50, 50, 50],
              lineWidth: 0.3,
            },
            alternateRowStyles: { fillColor: [245, 245, 245] },
            columnStyles: { 0: { halign: 'center', fontStyle: 'bold' } },
            margin: { top: titleY + 20 },
            pageBreak: 'auto',
            rowPageBreak: 'avoid',
            didDrawPage: function (data) {
              const pageCount = doc.getNumberOfPages();
              doc.setFontSize(10);
              doc.text(
                `Page ${pageCount}`,
                pageWidth - 20,
                doc.internal.pageSize.height - 10
              );
            },
          });

          // Save the PDF
          doc.save(pdfFileName);
        };
      };
    };
  }
}
